// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Button, Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ZenVerBIB from "./Common/Graph/ZenVerBIB";

import Angela1C from "./Common/Angela/Angela1C";

import Angela1R from "./Common/Angela/Angela1R";
import AngelaIcon1R from "./Common/Angela/AngelaIcon1R";
import AngelaIconMultiR2C from "./Common/Angela/AngelaIconMultiR2C";
import AngelaIconMultiR1C from "./Common/Angela/AngelaIconMultiR1C";

// import AngelaSingle2R1C from "./Angela/AngelaSingle2R1C";

// import ZenGoldenTunnel from "./Common/Graph/ZenGoldenTunnel";
// import ZenHorCandleStick from "./Common/Graph/ZenHorCandleStick";

// import ZenClusterColumnVer from "./Common/Graph/ZenClusterColumnVer";
// import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
// import ZenPieBar from "./Common/Graph/ZenPieBar";
// import ZenWaterfallChart from "./Common/Graph/ZenWaterfallChart";
// import ZenPareto from "./Common/Graph/ZenPareto";
// import ZenVerStackBar from "./Common/Graph/ZenVerStackBar";
// import ZenHorStackBar from "./Common/Graph/ZenHorStackBar";
import ZenGanttChart from "./Common/Graph/ZenGanttChart";
// import ZenStackedNePo from "./Common/Graph/ZenStackedNePo";
// import ZenDonut from "./Common/Graph/ZenDonut";
import ZenGauge from "./Common/Graph/ZenGauge";
import ZenGaugeOmega from "./Common/Graph/ZenGaugeOmega";


import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
import { getUrlCode } from "../../utils/CustomFunc";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class ZenChartArsenalTest extends React.Component {
  state = {
    mainData: null,
    AngelaIconMultiR2C: null,
    AngelaIconMultiR1C: null,
    Angela1C_SingleRow: null,
    Angela1C_MultiRow: null,
    Angela1R_SingleCol: null,
    AngelaIcon1R_SingleCol: null,
    AngelaIcon1R_SingleColDoubleLine: null,
    ZenGoldenTunnel: null,
    ZenHorCandleStick: null,
    ZenVerBarChart: null,
    ZenVerBarChart33: null,
    ZenVerBIB: null,
    ZenVerBarChartMultiColor: null,
    ZenHorBarChart: null,
    ZenWaterfallChart: null,
    ZenClusterColumnVer: null,
    ZenHorStackBar: null,
    ZenGanttChart: null,
    ZenPieBar: null,
    ZenDonut: null,
    ZenPareto: null,
    GtTrend: null,
    ZenVerStackBar: null,
    GtManpower: null,
    GtLpg: null,
    GtMseb: null,
    ZenGaugeVanilla: null,
    ZenGauge: null,
    ZenGaugeOmega: null,
    GtHorCostContributor: null,
    GaugeVBarB: null,
    GaugeVBarG: null,

    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    console.log("change--***");
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("Zen Chart Arsenal TEST");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all", params) => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "ZenChartArsenalTest",
        ...params
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenVerBarChart"] = resp["data"]["ZenVerBarChart"];
        respData["ZenVerBarChart33"] = resp["data"]["ZenVerBarChart33"];
        respData["ZenVerBIB"] = resp["data"]["ZenVerBIB"];
        respData["ZenGaugeOmega"] = resp["data"]["ZenGaugeOmega"];
        respData["ZenGauge"] = resp["data"]["ZenGauge"];

        // Houdini_respdata

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
          ? "all"
          : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#edf1f9",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#000000",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#edf1f9",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to={`/v02/${getUrlCode()}/dashboard`}>
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#e74c3c",
                          fontSize: 36,
                          fontWeight: 800,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                        ZEN CHART ARSENAL TEST
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}


                      <Row style={{ background: "#edf1f9" }}>
                        {/* <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",

                            width: "240px",
                          }}
                        >
                          <ZenHorBarChart
                            divId={"ZenHorBarChart1"}
                            data={this.state.ZenHorBarChart.data}
                            config={this.state.ZenHorBarChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div> */}

                        <div
                          style={{
                            borderRadius: "10px",
                            background: this.state.ZenVerBarChart33.config.chartDiv.style.background,
                            // border: "1px solid #3c3e4f",
                            boxShadow: "5px 5px 10px #d2cdcd, -5px -5px 10px #d2cdcd",
                            overflow: 'hidden',
                            margin: "10px 0px 0px 20px",
                            width: "380px",
                          }}
                        >
                          <ZenVerBarChart
                            divId={"ZenVerBarChart33"}
                            data={this.state.ZenVerBarChart33.data}
                            config={this.state.ZenVerBarChart33.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                            refreshData={(params) => {this.fetchTrendData(this.state.selectedTab, 'all', 'all', { ...params })}}
                          />

                          {/* <ZenVerBIB
                            divId={"ZenVerBIB"}
                            data={this.state.ZenVerBIB.data}
                            config={this.state.ZenVerBIB.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          /> */}
                        </div>
                        {/* <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 20px",
                              width: "380px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"ZenVerBarChartMultiColor"}
                              data={this.state.ZenVerBarChartMultiColor.data}
                              config={this.state.ZenVerBarChartMultiColor.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div> */}
                      </Row>

                      {/* _______Row No 5________ */}


                      {/* <Row style={{ background: "#000000" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 10px",

                              width: "600px",
                            }}
                          >
                            <ZenWaterfallChart
                              divId={"ZenWaterfallChart1"}
                              data={this.state.ZenWaterfallChart.data}
                              config={this.state.ZenWaterfallChart.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>

                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 20px",
                              width: "600px",
                            }}
                          >
                            <ZenClusterColumnVer
                              divId={"chartdiv"}
                              // respData = {this.state.ZenVerBarChart}
                              data={this.state.ZenClusterColumnVer.data}
                              config={this.state.ZenClusterColumnVer.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Row> */}

                      {/* <Row style={{ background: "#000000" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 10px",

                              width: "600px",
                            }}
                          >
                            <ZenPareto
                              divId={"ZenPareto01"}
                              data={this.state.ZenPareto.data}
                              config={this.state.ZenPareto.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>

                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 20px",
                              width: "600px",
                            }}
                          >
                            <ZenVerStackedBarChart
                              divId={"ZenVerStackedBarChart01"}
                              data={this.state.ZenVerStackedBarChart.data}
                              config={this.state.ZenVerStackedBarChart.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Row> */}

                      {/* <Row style={{ background: "#000000" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 10px",

                              width: "600px",
                            }}
                          >
                            <ZenDonut
                              divId={"ZenDonut01"}
                              data={this.state.ZenDonut.data}
                              config={this.state.ZenDonut.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>

                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 0px 0px 20px",
                              width: "600px",
                            }}
                          ></div>
                        </Row> */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default ZenChartArsenalTest;
